import { router } from '@/app/router/routes';
import { paths } from '@/app/router/paths';
import { msalInstance } from './msalConfig';

/**
 * Runs once in `main.tsx`, before the first render, so the app never renders with a half-finished
 * login. Sets the active account in this one place (cmps set it in two, one of which never ran).
 */
export const initAuth = async () => {
  await msalInstance.initialize();

  // Back from the Entra sign-in page: the result holds the new account.
  const result = await msalInstance.handleRedirectPromise({ navigateToLoginRequestUrl: false });
  if (result?.account) {
    msalInstance.setActiveAccount(result.account);
    await router.navigate(paths.home, { replace: true });
    return;
  }

  // A normal page load: pick up the account cached by an earlier sign-in.
  const [firstAccount] = msalInstance.getAllAccounts();
  if (!msalInstance.getActiveAccount() && firstAccount) {
    msalInstance.setActiveAccount(firstAccount);
  }
};
